import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import _ from 'lodash'

import { browserUtils } from '../../utils'
import { routeNames } from '../../routes'
import { LoadingIcon } from '../../components'
import warningIcon from '../../assets/icons/alert.svg'
import './FilteredSearchMatches.sass'


const colorClassMap = {
  'Decision-Support': 'green',
  'Visualization': 'orange',
  'Model': 'blue'
}

class FilteredSearchMatches extends Component {
  componentDidMount() {
    // If on mobile, fetch results up front (if there aren't already results to show)
    if (browserUtils.isMobileDevice() && !this.props.matches.exact.length) {
      this.props.fetchMatches(false)
    }
  }

  renderMatchCard(match, idx) {
    const truncatedPurpose = _.truncate(match.purpose, { length: 150 })

    return (
      <Link
        key={idx}
        to={`${routeNames.tool}${match.slug}`}
        className={`match-card ${colorClassMap[match.type]}`}
      >
        <div className="match-card-header text-upper">
          <div>{match.type}</div>
          <div>{match.cost}</div>
        </div>
        <div className="match-card-body">
          <h6>{match.name}</h6>
          <p dangerouslySetInnerHTML={{__html: truncatedPurpose}} />
          { match.photo &&
            <div className="match-card-overlay">
              <img src={match.photo} alt={match.name} />
            </div>
          }
        </div>
      </Link>
    )
  }

  render() {
    const { matches } = this.props

    if (matches.isFetching) {
      return <LoadingIcon />
    }

    if (!matches.exact.length && !matches.close.length) {
      return (
        <div className="filtered-search-no-matches">
          <img src={warningIcon} alt="warning" />
          <h1>Try removing filters to get more results</h1>
          <p className="hide-on-mobile">Click "Top Filters" or "More Filters" to keep searching</p>
        </div>
      )
    }

    return (
      <div className="filtered-search-matches">
        { matches.exact.length > 0 &&
          <div className="match-results-section">
            <div className="match-type-label">Exact Matches</div>
            <div className="match-results">{matches.exact.map(this.renderMatchCard)}</div>
          </div>
        }
        { matches.close.length > 0 &&
          <div className="match-results-section">
            <div className="match-type-label">Relevant Matches</div>
            <div className="match-type-sub-label">These tools match some filters exactly (e.g., Climate Change Topics, Geographic Scope), but may differ in areas where you have more flexibility (e.g., Cost Level, Level of Effort, etc.).</div>
            <div className="match-results">{matches.close.map(this.renderMatchCard)}</div>
          </div>
        }
        { matches.isMoreToFetch &&
          <button
            type="button"
            className="btn-blue-transparent"
            disabled={matches.isFetchingMore}
            onClick={() => this.props.fetchMatches(true)}
          >
            { matches.isFetchingMore ? 'loading...' : 'load more' }
          </button>
        }
      </div>
    )
  }
}

FilteredSearchMatches.propTypes = {
  fetchMatches: PropTypes.func,
  matches: PropTypes.object
}

export default FilteredSearchMatches
